/**
 * changelog.js — client wrapper for the changelogApi callable (RW-1642).
 *
 * The What's New log lives in the relational core (Postgres) behind a
 * server-authoritative domain API — there is NO client data path (RW-823) and
 * NO create action anywhere: entries are machine-published by the deploy scan
 * and flag flips; staff may hide/reword after the fact. Realtime comes from
 * the signals/{tenant}__changelog Firestore doc, never a direct DB connection.
 * Per-user callout state (users/{uid}.whatsNew*) is also written server-side,
 * so this module needs zero Firestore writes and zero rules changes.
 */
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

async function call(action, payload) {
  const callable = httpsCallable(functions, 'changelogApi');
  const result = await callable({ action, ...(payload || {}) });
  return result?.data;
}

export const changelogService = {
  // agent surfaces
  list: () => call('list'),
  get: (id) => call('get', { id }),
  callouts: () => call('callouts'),
  markVisited: () => call('markVisited'),
  ackModule: (module) => call('ackModule', { module }),
  ackSpotlight: (entryId, yieldedIds) => call('ackSpotlight', { entryId, yieldedIds }),
  markSeen: (entryIds) => call('markSeen', { entryIds }),
  markTried: (entryId) => call('markTried', { entryId }),
  // staff ship log
  adminList: () => call('adminList'),
  hide: (id) => call('hide', { id }),
  unhide: (id) => call('unhide', { id }),
  reword: (id, patch) => call('reword', { id, patch }),
  setRule: (key, enabled) => call('setRule', { key, enabled }),
  scanNow: () => call('scanNow'),
};
